import { ReactNode } from "react";
import { useParams } from "react-router-dom";
import { useProject } from "../lib/store";
import { useReveal } from "../lib/anim";
import type { Project } from "../lib/types";

export function useCurrent(): Project | undefined {
  const { pid } = useParams();
  return useProject(pid);
}

export function Page({ children, max = 1180 }: { children: ReactNode; max?: number }) {
  const ref = useReveal<HTMLDivElement>([]);
  return (
    <div ref={ref} className="page-wrap" style={{ padding: "34px 34px 80px" }}>
      <div style={{ maxWidth: max, margin: "0 auto" }}>{children}</div>
    </div>
  );
}

export const Grid = ({ cols, children, gap = 18, style }: { cols: string; children: ReactNode; gap?: number; style?: React.CSSProperties }) => (
  <div style={{ display: "grid", gridTemplateColumns: cols, gap, ...style }}>{children}</div>
);
